import { NativeSelect, type NativeSelectRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

const BRAZILIAN_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
]

type Props = NativeSelectRootProps & {
  name?: string
  defaultValue?: string
}

const BrazilianStateSelect = forwardRef<HTMLSelectElement, Props>(
  ({ name, defaultValue, ...props }, _ref) => (
    <NativeSelect.Root {...props}>
      <NativeSelect.Field name={name} defaultValue={defaultValue ?? ''}>
        <option value="">Selecione</option>
        {BRAZILIAN_STATES.map((uf) => (
          <option key={uf} value={uf}>
            {uf}
          </option>
        ))}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  ),
)

export default BrazilianStateSelect
